import { FormDocument } from '@/features/ui/DocumentsData/model/types';

import { addDocumentAttachments, AttachmentPayload, toArray } from '@/shared/lib/helpers/payloadHelpers';

import { getERZDocumentTypeEntites } from '@/modules/erz/helpers';

import { ServiceFileManager } from '@/helpers/serviceFileManager';

import { DocumentTypeCode } from '@/api/types';

import { MissingPersonExtractAttachmentsInput } from '../model/types';

export const collectAttachments = (formData: MissingPersonExtractAttachmentsInput): AttachmentPayload[] => {
  const attachments: AttachmentPayload[] = [];
  const { missingPerson, applicant } = formData;

  if (missingPerson.disappearance_document) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>(missingPerson.disappearance_document),
      'missingPerson.disappearance_document',
    );
  }

  if (applicant.additional_document) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>(applicant.additional_document),
      'applicant.additional_document',
    );
  }

  applicant.documents?.forEach((document, index) => {
    addDocumentAttachments(attachments, toArray<FormDocument>(document), `applicant.documents.${index}.0`);
  });

  return attachments.map((attachment) => ({ ...attachment, typeDoc: attachment.code ?? attachment.typeDoc }));
};

export const generateApplicationAttachment = async (
  serviceFileManager?: ServiceFileManager | null,
): Promise<AttachmentPayload | null> => {
  const applicationFileId = serviceFileManager?.getAttachment()?.fileId ?? undefined;
  if (!applicationFileId) {
    return null;
  }

  const [pdfDocumentType] = await getERZDocumentTypeEntites([DocumentTypeCode.MISSING_PERSON_EXTRACT]);
  const pdfCode = pdfDocumentType?.code && pdfDocumentType.code !== 'null' ? pdfDocumentType.code : pdfDocumentType?.id;
  const pdfLabel = pdfDocumentType?.label ?? pdfDocumentType?.id ?? 'application';
  const pdfId = pdfDocumentType?.id ?? pdfCode ?? pdfLabel;

  if (pdfDocumentType && pdfId && pdfCode && pdfLabel) {
    return {
      id: pdfId,
      typeDoc: pdfLabel,
      fileName: pdfLabel,
      code: pdfCode,
      info: {},
      formField: 'application',
      files: [applicationFileId],
    };
  }

  return null;
};
